const  hideValidationMessage = (targetElement)=> {
    const parent = targetElement.parentNode
    parent.classList.remove("wu-input--error");
    const errorElementDiv = parent.querySelector('.wu-input--error')
    if (errorElementDiv) {
        errorElementDiv.classList.add("d-none");
    }
}

const showValidationMessage = (targetElement,targetAttr)=> {
    const parent = targetElement.parentNode
    parent.classList.add("wu-input--error");
    const errorElementDiv = parent.querySelector('.wu-input--error')
    if (errorElementDiv) {
        if(targetAttr) {
            let message = errorElementDiv.getAttribute(targetAttr)
            errorElementDiv.innerText = message
        }
        errorElementDiv.classList.remove("d-none");
    }
}


const emailValidation = (targetElement) => {
    const mailformat = /^(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)/;
    return targetElement?.value?.length <= 80 && mailformat.test(targetElement.value)
}


const specialCharValidation = (targetElement) => {
    const sFormat = /[^a-zA-Z0-9]/
    return targetElement.value.match(sFormat)
}

const passwordValidation = (targetElement) => {
    const passwordFormat = /((?=.*[a-z])(?=.*[A-Z])(?=.*[0123456789])^.{8,16}$)/;
    return passwordFormat.test(targetElement.value)
}

const charLengthValidation = (targetElement) => {
    let val = targetElement.value;
return val.length >= 8 && val.length<=16 ? true: false; 
}


const capitalLettersValidation = (targetElement) => {
    const sFormat = /[A-Z]/
    return sFormat.test(targetElement.value)
}

const smallLettersValidation = (targetElement) => {
    const sFormat = /[a-z]/
    return sFormat.test(targetElement.value)
}

const numbersValidation = (targetElement) => {
    const sFormat =/[0-9]/
    return sFormat.test(targetElement.value)
}

const phoneValidation = (targetElement) => {
    return targetElement.value.match(phoneformat)
}

const phoneValidationWithoutPlus = (targetElement) => {
    const phoneformatWithoutPlus = /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    return targetElement.value.match(phoneformatWithoutPlus)
}


export {
    hideValidationMessage,
    showValidationMessage,
    emailValidation,
    phoneValidation,
    phoneValidationWithoutPlus,
    capitalLettersValidation,
    smallLettersValidation,numbersValidation,
    passwordValidation,charLengthValidation,specialCharValidation
}
